import { defineMessages, IntlShape } from 'react-intl';
import { keyForString } from './index';

/**
 * Known booking/checkout setting labels that guides can configure.
 *
 * Values come from tour.settings (e.g. continue_booking_label.value,
 * submit_booking_label.value). The old t() function converted them to
 * UPPER_CASE keys via keyForString() and looked them up in the locale
 * files.  This defineMessages map covers the known defaults so the
 * extraction tool can find them; custom guide-set labels fall through
 * to the raw value.
 */
const settingLabelMessages = defineMessages({
  CONTINUE_BOOKING: { defaultMessage: 'Continue Booking' },
  CONFIRM_PURCHASE: { defaultMessage: 'Confirm Purchase' },
  BOOK_NOW: { defaultMessage: 'Book Now' },
  CONTINUE: { defaultMessage: 'Continue' },
  SUBMIT: { defaultMessage: 'Submit' },
});

/**
 * Translate a guide-configurable setting label.
 *
 * Converts the raw value to an UPPER_CASE key (matching locale file
 * conventions), looks it up in the defineMessages map, and returns the
 * translated string.  Falls back to the raw value when the key is not
 * in the map (i.e. the guide entered a fully custom label).
 */
export const translateSettingLabel = (
  intl: IntlShape,
  value: string | null | undefined
): string => {
  if (!value) return '';
  const key = keyForString(value) as keyof typeof settingLabelMessages;
  if (key in settingLabelMessages) {
    return intl.formatMessage(settingLabelMessages[key]);
  }
  return value;
};
